// extracted by mini-css-extract-plugin
export default {"input":"styles_input__mHSPh","checkbox":"styles_checkbox__GNmsh","link":"styles_link__EbLvD","buttons":"styles_buttons__9+CCS"};